import fetch from "cross-fetch";

const gaHeaders = () => {
  let csrfElement = document.querySelector('meta[name="csrf-token"]');
  let csrf        = csrfElement ? csrfElement.getAttribute("content") : "";

  return {
    "Content-Type":     "application/json; charset=UTF-8",
    "Accept":           "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-Token":     csrf,
  };
};

/**
 *
 * @param {String} url Url of request
 * @param {String} method Method of request: GET, POST, PUT, etc
 * @param {Object} data Data to encode in response body for put requests
 * @param {Function} fn callback with the signature (data, error)
 *
 * The callback function is called with two parameters (data, error). Data is whatever the response from the server
 * for this endpoint is, assuming there are no errors. If there are errors, data will be null.
 * If there are no errors, errors will be null.
 * In this context, "errors" do not include validation errors – only errors with the network communication itself
 */
const networkJsonRequest = (url, method, data, fn) => {
  if (!url) {
    fn(null, t("react_http.assertion_failed_no_url"));
    return;
  }

  let safeMethod = method.toUpperCase();

  let options = {
    headers: gaHeaders(),
    method: safeMethod,
    redirect: ( safeMethod === "DELETE" ) ? "manual" : "follow",
  };

  if (data) {
    if (safeMethod === "GET") {
      fn(null, t("react_http.assertion_failed_body_not_supported_on_get"));
      return;
    }

    options.body = JSON.stringify(data);
  }

  fetch(url, options).then(
    (response) => {
      if (response.ok) {
        response.json().then(
          (responseJSON) => {
            fn(responseJSON, null);
          },
          (responseParseError) => {
            fn(null, t("react_http.json_parse_error"));
          },
        );
      } else {
        fn(null, t("react_http.http_non_ok_response"));
      }
    },
    (rejection) => {
      fn(null, t("react_http.http_network_error"));
    },
  );
};

export const getJSON = (url, fn) => {
  networkJsonRequest(url, "get", null, fn);
};

export const postJSON = (url, data, fn) => {
  networkJsonRequest(url, "post", data, fn);
};

export const putJSON = (url, data, fn) => {
  networkJsonRequest(url, "put", data, fn);
};

export const deleteJSON = (url, fn) => {
  networkJsonRequest(url, "delete", null, fn);
};

export const getRaw = (url, fn) => {
  if (!url) {
    fn(null, t("react_http.assertion_failed_no_url"));
    return;
  }

  fetch(url, {
    method: "GET",
    headers: gaHeaders(),
  }).then(
    (response) => {
      if (response.ok) {
        response.text().then((data) => {
          fn(data, null);
        });
      } else {
        fn(null, t("react_http.http_non_ok_response"));
      }
    },
    (error) => {
      fn(null, t("react_http.http_network_error"));
    },
  );
};
